import { render } from "./TxtPreview.vue?vue&type=template&id=0b1bb20c&scoped=true"
import script from "./TxtPreview.vue?vue&type=script&lang=js"
export * from "./TxtPreview.vue?vue&type=script&lang=js"

import "./TxtPreview.vue?vue&type=style&index=0&id=0b1bb20c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1bb20c"]])

export default __exports__